import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';

const useAnalytics = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog) {
      // Anonymous identification for unauthenticated users
      posthog.identify();
    } else {
      console.warn('PostHog is not initialized');
    }
  }, []);

  const captureEvent = (eventName: string, eventProperties: Record<string, any> = {}) => {
    if (posthog) {
      try {
        posthog.capture(eventName, {
          ...eventProperties,
        });
      } catch (error) {
        console.error('Error capturing event:', error);
      }
    } else {
      console.warn('PostHog is not initialized');
    }
  };

  return {
    captureEvent,
  };
};

export default useAnalytics;